import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {GiftCardModel} from './GiftCard.model';
import {GiftCardFragment, AddressWithContactFragment} from '../../../../gql/graphql';
import {AddressModel} from './Address.model';
import {ContactModel} from './Contact.model';
import {AddressWithContactModel} from './AddressWithContact.model';

export class PaymentInfoModel extends AddressWithContactModel {
  public currencyCode?: string;
  public giftCard?: GiftCardModel;

  constructor(params: PaymentInfoModel) {
    super(params);
    this.currencyCode = params.currencyCode;
    this.giftCard = params.giftCard;
  }

  public static fromCheckoutV1({
    currencyCode,
    giftCard,
    billingInfo,
  }: {
    currencyCode?: string | null;
    giftCard?: GiftCardFragment | null;
    billingInfo?: AddressWithContactFragment | null;
  }) {
    return new PaymentInfoModel({
      currencyCode: mapNullToUndefined(currencyCode),
      giftCard: GiftCardModel.fromCheckoutV1(giftCard),
      address: AddressModel.fromCheckoutV1(billingInfo?.address),
      contact: ContactModel.fromCheckoutV1(billingInfo?.contactDetails),
      addressId: mapNullToUndefined(billingInfo?.addressesServiceId),
    });
  }
}
